import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EmailIcon from '@mui/icons-material/Email';
import "./kontakt.scss";

const Kontakt = () => {

    const [kontakte, setKontakte] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const kontakteRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/kontakte`);
                if (kontakteRes.data && kontakteRes.data.length > 0) {
                    setKontakte(kontakteRes.data);
                }
                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="kontakt">
            <Helmet>
                <title>Kontakt | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <motion.div
                className="header"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <h1>Kontakt</h1>
            </motion.div>
            <div className="container">
                <div className="grid">
                    <motion.div
                        className="left"
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <h2>Musikkapelle St. Lorenzen EO</h2>
                        <p>
                            Franz Hellweger Platz 3A<br />
                            39030 St. Lorenzen (BZ)<br />
                            Südtirol - Italien
                        </p>
                        <div className="links">
                            <Link to="mailto:info@mk-lorenzen.it">
                                <EmailIcon />
                                <span>info@mk-lorenzen.it</span>
                            </Link>
                            <Link to="">
                                <RequestQuoteIcon />
                                <span>Steuernummer: 81009250218</span>
                            </Link>
                        </div>

                    </motion.div>
                    <motion.img
                        src="https://mk-lorenzen.it/admin/wp-content/uploads/2024/11/MKSTL-Final_Edit-scaled.jpg"
                        alt="Kapelle"
                        className="right"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    />
                </div>
                <div className="contacts">
                    {!isLoading && kontakte.map((kontakt, index) => {
                        const delay = (index % 5) * 0.1;

                        return (
                            <motion.div
                                className="item"
                                key={index}
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay }}
                            >
                                <h2>{kontakt.title.rendered}</h2>
                                <span>{kontakt.acf.name}</span>
                                <Link className="lineLink" to={`tel:${kontakt.acf.mobile}`}>{kontakt.acf.mobile}</Link>
                                <Link className="lineLink" to={`mailto:${kontakt.acf.email}`}>{kontakt.acf.email}</Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Kontakt;
